// features/user/userSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import axios from 'axios';
import APIURL from '../../components/Constant';


// Async login call
export const loginUser = createAsyncThunk(
  'user/loginUser',
  async ({ email, password }, thunkAPI) => {
    try {
      const response = await axios.post(
        APIURL+'/user-service/auth/admin-sign-in',
        { email, password }
      );
      // Store user in cookie
      Cookies.set('user', JSON.stringify(response.data), { expires: 7 });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || { message: 'Login failed' });
    }
  }
);

// Load user from cookie
export const loadUserFromCookie = createAsyncThunk(
  'user/loadUserFromCookie',
  async (_, thunkAPI) => {
    try {
      const user = Cookies.get('user');
      if (user) return JSON.parse(user);
      return null;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);


export const validateToken = createAsyncThunk(
  'user/validateToken',
  async (_, thunkAPI) => {
    try {
      const user = Cookies.get('user');

      if (!user) throw new Error('No user found in cookie');

      const parsedUser = JSON.parse(user);
      const token = parsedUser?.access; 

      if (!token) throw new Error('No token found');

      // Call your backend to validate token
      const response = await axios.get(APIURL+'/user-service/user/', {
        headers: { Authorization: `Bearer ${token}` },
      });

      return { ...parsedUser, ...response.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || { message: 'Invalid token' });
    }
  }
);


const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: null,
    loading: true, // <-- start in loading mode
    error: null,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.loading = false;
      Cookies.remove('user'); // remove cookie on logout
    },
  },
  extraReducers: (builder) => {
    builder
      // --- loginUser ---
      .addCase(loginUser.pending, (state) => {
        state.loading = true;   // set true on login request
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Login failed';
      })

      // --- loadUserFromCookie ---
      .addCase(loadUserFromCookie.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadUserFromCookie.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;  // finish loading after cookie check
      })
      .addCase(loadUserFromCookie.rejected, (state) => {
        state.user = null;
        state.loading = false;  // still end loading
      })
       .addCase(validateToken.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(validateToken.fulfilled, (state, action) => {
      state.user = action.payload;
      state.loading = false;
    })
    .addCase(validateToken.rejected, (state, action) => {
      state.user = null;
      state.loading = false;
      state.error = action.payload?.message || 'Invalid token';
      Cookies.remove('user'); // clear invalid cookie
    });

  },
});

export const { logout } = userSlice.actions;
export default userSlice.reducer;

